import React, { Component } from "react";
import { Container } from "./styles";
import Spinner from "../SpinnerSmall";
import Icon from "../Icon";
import { withRouter } from "react-router-dom";
import { Icon as AntIcon } from "antd";

class Message extends Component {
  getIcon = () => {
    switch (this.props.type) {
      case "default":
        return <span />;
      case "error":
        return <Icon type="triangle-alert" size="xs" color="#C48A45" label="error" />;
      case "success":
        return (
          <AntIcon
            style={{ color: "#6E70B0", fontWeight: "800" }}
            type="check"
            twoToneColor="#6E70B0"
          />
        );
      case "warning":
        return <Icon type="triangle-alert" size="xs" color="#C48A45" label="warning" />;
      case "loading":
        return <Spinner />;
      default:
        return <span />;
    }
  };

  render() {
    return (
      <Container
        type={this.props.type}
        clickable={!!this.props.redirectLink}
        onClick={
          this.props.redirectLink
            ? () => this.props.history.push(this.props.redirectLink)
            : undefined
        }
      >
        <div className="message-header">
          <div className="title-container">
            <span className="icon-container">{this.getIcon()}</span>
            {this.props.heading ? (
              <div className="text-stack">
                <p className="heading">{this.props.heading}</p>
                <p className="subtext">{this.props.description}</p>
              </div>
            ) : (
              <p className="title">{this.props.description}</p>
            )}
          </div>
          <Icon
            className="close"
            type="close"
            size="sm"
            color="white"
            label="close"
            onClick={event => {
              this.props.closeMessage();
              event.stopPropagation();
            }}
          />
        </div>
      </Container>
    );
  }
}

export default withRouter(Message);
